import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { IPdfViewerDialogData, PdfViewerDialogComponent } from './pdf-viewer-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class PdfViewerDialogService {
    constructor(private readonly cbDialog: CbDialogService) {}

    public open(data: IPdfViewerDialogData): MatDialogRef<PdfViewerDialogComponent> {
        return this.cbDialog.open(PdfViewerDialogComponent, {
            data,
            width: '92vw',
            maxWidth: '92vw',
            height: '96dvh',
            maxHeight: '96dvh',
            disableClose: false,
            autoFocus: false,
            panelClass: ['cb-dialog-container', 'cb-pdf-viewer-dialog-container']
        });
    }
}
